"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("@emotion/react");

var react_2 = require("react");

var components_utils_1 = require("@conte-ltd/components-utils");

var kindDict = {
  menu: 'e68e',
  close: 'e646',
  'arrow-up': 'e627',
  'arrow-right': 'e628',
  'arrow-left': 'e629',
  'arrow-down': 'e62a',
  'arrow-circle-up': 'e65c',
  'arrow-circle-right': 'e65d',
  'arrow-circle-left': 'e65e',
  'arrow-circle-down': 'e65f',
  'angle-up': 'e648',
  'angle-right': 'e649',
  'angle-left': 'e64a',
  'angle-down': 'e64b',
  'angle-double-up': 'e660',
  'angle-double-right': 'e661',
  'angle-double-left': 'e662',
  'angle-double-down': 'e663',
  'external-link': 'e732',
  download: 'e6a7',
  plus: 'e61a',
  minus: 'e622',
  check: 'e64c',
  checkbox: 'e64d',
  info: 'e697',
  help: 'e69c',
  'info-alt': 'e717',
  'help-alt': 'e718',
  settings: 'e60f',
  calendar: 'e6b6',
  timer: 'e66e',
  mobile: 'e621',
  email: 'e75a',
  facebook: 'e741',
  instagram: 'e73d',
  twitter: 'e74b',
  'twitter-outline': 'e72a',
  youtube: 'e728'
};

function _Icon(props, fwRef) {
  var type = props.type;
  return (0, jsx_runtime_1.jsx)("span", __assign({
    css: [(0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          font-family: themify, sans-serif;\n          font-style: normal;\n          font-weight: normal;\n          font-variant: normal;\n          text-transform: none;\n          line-height: 1;\n          -webkit-font-smoothing: antialiased;\n          -moz-osx-font-smoothing: grayscale;\n        "], ["\n          font-family: themify, sans-serif;\n          font-style: normal;\n          font-weight: normal;\n          font-variant: normal;\n          text-transform: none;\n          line-height: 1;\n          -webkit-font-smoothing: antialiased;\n          -moz-osx-font-smoothing: grayscale;\n        "]))), Object.entries(kindDict).map(function (_a) {
      var _b = __read(_a, 2),
          key = _b[0],
          value = _b[1];

      return (0, react_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            &[data-icon-type='", "'] {\n              &::before {\n                content: '\\", "';\n              }\n            }\n          "], ["\n            &[data-icon-type='", "'] {\n              &::before {\n                content: '\\\\", "';\n              }\n            }\n          "])), key, value);
    })],
    "data-icon-type": type,
    ref: fwRef
  }, (0, components_utils_1.styleProps)(props)), void 0);
}

exports.Icon = (0, react_2.forwardRef)(_Icon);
var templateObject_1, templateObject_2;